import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import "./Pagination.scss";
import { Select } from "@livingdesign/react";

function Pagination({
  totalItems,
  itemsPerPageOptions,
  itemsPerPage,
  setItemsPerPage,
  itemOffset,
  setItemOffset,
  currentPage,
  setCurrentPage
}) {

  const pageCount = Math.ceil(totalItems / parseInt(itemsPerPage));

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    const newOffset = (event.selected * parseInt(itemsPerPage)) % totalItems;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    setItemOffset(0);
    setCurrentPage(0);
  }, [itemsPerPage]);

  return (
    <>
      <div className="pagination-container">
        <div className="pagination-items-per-page">
          <div style={{ flexShrink: 0 }}>Items per page</div>
          <Select
            size="small"
            onChange={(e) => setItemsPerPage(parseInt(e.target.value))}
          >
            {itemsPerPageOptions.map((option, index) => (
              <option
                key={index}
                value={option}
                selected={option === itemsPerPage}
              >
                {option}
              </option>
            ))}
          </Select>
          <div style={{ flexShrink: 0 }}>
            {totalItems === 0
              ? "0-0 of 0"
              : `${itemOffset + 1}-${Math.min(
                  itemOffset + parseInt(itemsPerPage),
                  totalItems
                )} of ${totalItems}`}
          </div>
        </div>

        <ReactPaginate
          breakLabel="..."
          // nextLabel={null}
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          marginPagesDisplayed={0}
          pageCount={pageCount}
          // previousLabel=""
          renderOnZeroPageCount={null}
          className="pagination"
          activeClassName="active-page-item"
          pageClassName="page-item"
          previousClassName="prev-btn"
          nextClassName="next-btn"
          pageLinkClassName="page-link"
          breakClassName="break-item"
          forcePage={currentPage}
        />
      </div>
    </>
  );
}

export default Pagination;
